// Where to send someone after they sign in: back to the page they asked for,
// as long as it is on this site. A `redirect` that pointed elsewhere
// (//evil.com, /\\evil.com, https://…, javascript:…) would make the login page
// an open redirect, so anything that does not resolve to this origin is "/".
export const safeRedirect = (value) => {
  if (!value) return '/';
  try {
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : '/';
  } catch {
    return '/';
  }
};

// The login URL that brings someone back to where they are now
export const loginFor = (location) =>
  `/login?redirect=${encodeURIComponent(`${location.pathname}${location.search}`)}`;
